import { Injectable } from '@angular/core';
import { UserContext } from '../models/user-context.model';

@Injectable({
  providedIn: 'root'
})
export class TokenStore {
  private _sessionToken: string;
  private _userToken: UserContext = new UserContext();

  public setSessionToken(token: string): void {
    this._sessionToken = token;
  }

  public getSessionToken(): string {
    return this._sessionToken;
  }

  public setUserContext(userToken: UserContext): void {
    this._userToken = userToken;
  }

  public getUserContext(): UserContext {
    return this._userToken;
  }
}
